import {Injectable} from '@angular/core';
import {DatasourceService} from '../../../form-builder/services/datasource/datasource.service';
import {FieldValue} from '../../../form-renderer/interfaces/FieldValue';

import {FieldOption} from '../../../form-renderer/interfaces/FieldOption';

@Injectable()
export class SelectFieldService {

  private optionCache = {};

  constructor(private dataSourceService: DatasourceService) { }

  public getOptions(fieldValue: FieldValue): Promise<FieldOption[]> {
    if (fieldValue.field.datasource === 'manual' || fieldValue.field.datasource == null)
      return Promise.resolve(fieldValue.field.options);

    if (this.optionCache[fieldValue.field.datasource])
      return Promise.resolve(this.optionCache[fieldValue.field.datasource]);

    return this.dataSourceService.getDataSource(fieldValue.field.datasource).then((options) => {
      this.optionCache[fieldValue.field.datasource] = options;
      return options;
    });
  }

  /**
   * Gets the human readable version of the current selected item using the given options and rawValue
   * @param options
   * @param rawValue The option id of the current selected Item
   * @returns {string}
   */
  public getSelected(options, rawValue): string {
    const option =  options.find((cOption) => cOption.id == rawValue);
    if (option)
      return option.name;
    else
      return '';
  }

  /**
   * Get Human Readable value. This will retrieve the options
   * @param fieldValue
   * @returns {Promise<string>}
   */
  public getSelectValue(fieldValue: FieldValue): Promise<string> {
    if (fieldValue.select_value == null)
      return Promise.resolve('');

    return this.dataSourceService.getDataSource(fieldValue.field.datasource).then((options) =>
       this.getSelected(options, fieldValue.select_value)
    );
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/services/select-field/select-field.service.ts